// extracted by mini-css-extract-plugin
module.exports = {"truncate":"styles_truncate__3Ty2o","high":"styles_high__2hu3d","mid":"styles_mid__HJY4t","low":"styles_low__1_4LU"};